import ManaParticle from "../../../ManaParticle"
import ManaZoneNode, { ManaZoneNodeOptions } from "../../ManaZoneNode"
import NodeCategories from "../../NodeCategories"

export type SwitchZoneNodeOptions = {} & ManaZoneNodeOptions

export default class SwitchZoneNode extends ManaZoneNode {

	static nodeType = 'SwitchZoneNode'
	static nodeName = "Switch zone node"
	static nodeDesc = "Entering closes entry to this node, exit zone to allow entry again"
	static nodeIcon = '✅'
	static category = NodeCategories.Logistics

	constructor(options: SwitchZoneNodeOptions) {
		super(options)

		this.symbol = this.getSymbol()
	}

	open = true

	getSymbol() {
		return this.open ? '✅' : '🛑'
	}

	setOpen(open: boolean) {
		this.open = open
		this.reloadSymbol()
	}

	allowEntry(particle: ManaParticle) {
		if (particle.memory[this.uuid]) return true
		return this.open
	}

	async act(particle: ManaParticle) {
		if (particle.memory[this.uuid]) {
			particle.memory[this.uuid] = false
			this.setOpen(true)
			return false
		} else {
			particle.memory[this.uuid] = true
			this.setOpen(false)
			return true
		}
	}

}